import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Sidebar from "./components/Sidebar";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import { ForgotPasswordPage, ResetPasswordPage } from "./pages/PasswordResetPages";
import DashboardPage from "./pages/DashboardPage";
import CheckInPage from "./pages/CheckInPage";
import CheckinsPage from "./pages/CheckinsPage";
import AppointmentsPage from "./pages/AppointmentsPage";
import MessagesPage from "./pages/MessagesPage";
import GoalsPage from "./pages/GoalsPage";
import ResourcesPage from "./pages/ResourcesPage";
import DocumentsPage from "./pages/DocumentsPage";
import ClientsPage from "./pages/ClientsPage";
import SessionNotesPage from "./pages/SessionNotesPage";
import FlagsPage from "./pages/FlagsPage";
import GroupSessionsPage from "./pages/GroupSessionsPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import CompliancePage from "./pages/CompliancePage";
import UsersPage from "./pages/UsersPage";
import SettingsPage from "./pages/SettingsPage";
import BioPage from "./pages/BioPage";
import PeerDocsPage from "./pages/PeerDocsPage";
import ProgramsPage from "./pages/ProgramsPage";
import GeofencingPage from "./pages/GeofencingPage";
import NotificationsPage from "./pages/NotificationsPage";
import OrganizationProfilePage from "./pages/OrganizationProfilePage";
import PostOpportunityPage from "./pages/PostOpportunityPage";
import MyOpportunitiesPage from "./pages/MyOpportunitiesPage";
import OpportunitiesPage from "./pages/OpportunitiesPage";
import ReferralsPage from "./pages/ReferralsPage";
import InsightsPage from "./pages/InsightsPage";
import RoadmapPage from "./pages/RoadmapPage";
import EmploymentHubPage from "./pages/EmploymentHubPage";
import AchievementsPage from "./pages/AchievementsPage";
import JourneyPage from "./pages/JourneyPage";
import JourneyReportPage from "./pages/JourneyReportPage";
import CoursesPage from "./pages/CoursesPage";
import CalendarPage from "./pages/CalendarPage";
import GroupNotesPage from "./pages/GroupNotesPage";
import PublicReferralPage from "./pages/PublicReferralPage";
import PublicResourceSubmitPage from "./pages/PublicResourceSubmitPage";
import HousingPage from "./pages/HousingPage";
import ReferralManagementPage from "./pages/ReferralManagementPage";
import OurSquarePage from "./pages/oursquare/OurSquarePage";
import OurSquareApplyPage from "./pages/oursquare/OurSquareApplyPage";
import OnboardingPage from "./pages/oursquare/OnboardingPage";
import ResidentPortal from "./pages/oursquare/ResidentPortal";
import StaffCurriculumDashboard from "./pages/oursquare/StaffCurriculumDashboard";
import IntakeApplicationsPage from "./pages/oursquare/IntakeApplicationsPage";
import MilestonesPage from "./pages/oursquare/MilestonesPage";
import ReferralSourcesPage from "./pages/oursquare/ReferralSourcesPage";
import HousingDocumentsPage from "./pages/oursquare/HousingDocumentsPage";
import StaffDashboardPage from "./pages/oursquare/StaffDashboardPage";
import ResidentMilestonesPage from "./pages/oursquare/ResidentMilestonesPage";
import ResidentDocumentsPage from "./pages/oursquare/ResidentDocumentsPage";
import RiskScoringPage from "./pages/oursquare/RiskScoringPage";
import ComplianceReportsPage from "./pages/oursquare/ComplianceReportsPage";
import ComplianceDashboardPage from "./pages/oursquare/ComplianceDashboardPage";
import HeatDashboardPage from "./pages/heat/HeatDashboardPage";
import HeatModulesPage from "./pages/heat/HeatModulesPage";
import HeatFacilitatorsPage from "./pages/heat/HeatFacilitatorsPage";
import HeatAttendancePage from "./pages/heat/HeatAttendancePage";
import HeatSignInPage from "./pages/heat/HeatSignInPage";
import HeatReferralPortalPage from "./pages/heat/HeatReferralPortalPage";
import HeatMessagesPage from "./pages/heat/HeatMessagesPage";
import SessionDocumentationPage from "./pages/heat/SessionDocumentationPage";
import ClassSignInPage from "./pages/heat/ClassSignInPage";
import FacilitatorLiveDashboard from "./pages/heat/FacilitatorLiveDashboard";
import HerDashboardPage from "./pages/her/HerDashboardPage";
import HerModulesPage from "./pages/her/HerModulesPage";
import HerFacilitatorsPage from "./pages/her/HerFacilitatorsPage";
import HerAttendancePage from "./pages/her/HerAttendancePage";
import HerSignInPage from "./pages/her/HerSignInPage";
import HerReferralPortalPage from "./pages/her/HerReferralPortalPage";
import HerMessagesPage from "./pages/her/HerMessagesPage";
import ServiceLedgerPage from "./pages/ServiceLedgerPage";
import ImpactDashboardPage from "./pages/ImpactDashboardPage";
import AgencyViewPage from "./pages/AgencyViewPage";
import ScoreboardPage from "./pages/ScoreboardPage";
import AdminSecurityDashboard from "./pages/admin/AdminSecurityDashboard";
import CommunityPartnerPortal from "./pages/partner/CommunityPartnerPortal";
import ConnectionsPage from "./pages/ConnectionsPage";
import MyNeedsPage from "./pages/MyNeedsPage";
import ROICalculatorPage from "./pages/reports/ROICalculatorPage";
import RecidivismTrackingPage from "./pages/reports/RecidivismTrackingPage";
import ImpactReportPage from "./pages/reports/ImpactReportPage";
import ComplianceReportPage from "./pages/reports/ComplianceReportPage";
import ResourceWalletPage from "./pages/ResourceWalletPage";
import AlumniNetworkPage from "./pages/AlumniNetworkPage";
import CourtCasesPage from "./pages/court/CourtCasesPage";
import RiskDashboardPage from "./pages/risk/RiskDashboardPage";
import NotificationSchedulerPage from "./pages/admin/NotificationSchedulerPage";
import RoleGuard from "./components/RoleGuard";
import CrisisButton from "./components/CrisisButton";
import ConsentWizard from "./components/ConsentWizard";
import DemoBar from "./components/DemoBar";
import NotificationBell from "./components/NotificationBell";
import DemoPage from "./pages/DemoPage";
import DigestPage from "./pages/DigestPage";
import ApprovalQueuePage from "./pages/ApprovalQueuePage";
import MagicLinksPage from "./pages/MagicLinksPage";
import Core8AssessmentPage from "./pages/Core8AssessmentPage";
import RiskEnginePage from "./pages/risk/RiskEnginePage";
import MySupportStatusPage from "./pages/MySupportStatusPage";
import IncidentCompliancePage from "./pages/IncidentCompliancePage";
import RegionsPage from "./pages/RegionsPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-3 border-teal-600 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  return children;
}

function AppLayout({ children }) {
  const isDemo = localStorage.getItem('demo_mode') === 'true';
  return (
    <div className="flex min-h-screen bg-background">
      <DemoBar />
      <Sidebar />
      <main className={`flex-1 min-h-screen lg:pl-0 pl-0 ${isDemo ? 'pt-10' : ''}`}>
        <div className="flex justify-end px-4 md:px-6 lg:px-8 pt-3 pb-0 max-w-7xl">
          <NotificationBell />
        </div>
        <div className="p-4 md:p-6 lg:p-8 pt-2 max-w-7xl">
          {children}
        </div>
      </main>
      <CrisisButton />
      <ConsentWizard />
    </div>
  );
}

// Role groups
const CLIENT = ['client'];
const RESIDENT = ['housing_resident'];
const FACILITATOR = ['facilitator'];
const STAFF = ['peer_specialist', 'coordinator', 'admin', 'network_admin'];
const ADMIN = ['coordinator', 'admin', 'network_admin'];
const HOUSING = ['housing_coordinator', 'housing_staff'];
const AGENCY = ['referral_source', 'court_officer'];
const PARTNER = ['resource_partner'];
const HEAT_ROLES = ['client', 'facilitator', 'coordinator', 'admin', 'referral_source'];
const HER_ROLES = HEAT_ROLES;
const ALL_STAFF = [...STAFF, ...HOUSING];
const ALL_INTERNAL = [...STAFF, ...HOUSING, ...AGENCY];
const CLIENT_AND_STAFF = [...CLIENT, ...STAFF, ...RESIDENT];
const ALL_USERS = [...CLIENT, ...RESIDENT, ...STAFF, ...FACILITATOR, ...HOUSING, ...AGENCY, 'resource_partner'];

function R({ roles, children }) {
  return <ProtectedRoute><AppLayout><RoleGuard allowedRoles={roles}>{children}</RoleGuard></AppLayout></ProtectedRoute>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <LoginPage />} />
      <Route path="/register" element={user ? <Navigate to="/dashboard" /> : <RegisterPage />} />
      <Route path="/forgot-password" element={user ? <Navigate to="/dashboard" /> : <ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/demo" element={<DemoPage />} />
      <Route path="/our-square/apply" element={<OurSquareApplyPage />} />
      <Route path="/refer" element={<PublicReferralPage />} />
      <Route path="/submit-resource" element={<PublicResourceSubmitPage />} />

      {/* Universal — all logged-in users */}
      <Route path="/dashboard" element={<R roles={ALL_USERS}><DashboardPage /></R>} />
      <Route path="/settings" element={<R roles={ALL_USERS}><SettingsPage /></R>} />
      <Route path="/notifications" element={<R roles={ALL_USERS}><NotificationsPage /></R>} />
      <Route path="/messages" element={<R roles={ALL_USERS}><MessagesPage /></R>} />
      <Route path="/resources" element={<R roles={ALL_USERS}><ResourcesPage /></R>} />

      {/* HEAT Program */}
      <Route path="/heat" element={<R roles={HEAT_ROLES}><HeatDashboardPage /></R>} />
      <Route path="/heat/modules" element={<R roles={HEAT_ROLES}><HeatModulesPage /></R>} />
      <Route path="/heat/session-docs" element={<R roles={HEAT_ROLES}><SessionDocumentationPage program="heat" /></R>} />
      <Route path="/heat/facilitators" element={<R roles={HEAT_ROLES}><HeatFacilitatorsPage /></R>} />
      <Route path="/heat/attendance" element={<R roles={HEAT_ROLES}><HeatAttendancePage /></R>} />
      <Route path="/heat/signin" element={<R roles={HEAT_ROLES}><ClassSignInPage program="heat" /></R>} />
      <Route path="/heat/live-class" element={<R roles={HEAT_ROLES}><FacilitatorLiveDashboard program="heat" /></R>} />
      <Route path="/heat/referral-portal" element={<R roles={['referral_source', 'admin', 'coordinator']}><HeatReferralPortalPage /></R>} />
      <Route path="/heat/messages" element={<R roles={HEAT_ROLES}><HeatMessagesPage /></R>} />

      {/* HER Program */}
      <Route path="/her" element={<R roles={HER_ROLES}><HerDashboardPage /></R>} />
      <Route path="/her/modules" element={<R roles={HER_ROLES}><HerModulesPage /></R>} />
      <Route path="/her/session-docs" element={<R roles={HER_ROLES}><SessionDocumentationPage program="her" /></R>} />
      <Route path="/her/facilitators" element={<R roles={HER_ROLES}><HerFacilitatorsPage /></R>} />
      <Route path="/her/attendance" element={<R roles={HER_ROLES}><HerAttendancePage /></R>} />
      <Route path="/her/signin" element={<R roles={HER_ROLES}><ClassSignInPage program="her" /></R>} />
      <Route path="/her/live-class" element={<R roles={HER_ROLES}><FacilitatorLiveDashboard program="her" /></R>} />
      <Route path="/her/referral-portal" element={<R roles={['referral_source', 'admin', 'coordinator']}><HerReferralPortalPage /></R>} />
      <Route path="/her/messages" element={<R roles={HER_ROLES}><HerMessagesPage /></R>} />

      {/* HEAT for Youth */}
      <Route path="/youth/signin" element={<R roles={HEAT_ROLES}><ClassSignInPage program="youth" /></R>} />
      <Route path="/youth/live-class" element={<R roles={HEAT_ROLES}><FacilitatorLiveDashboard program="youth" /></R>} />
      <Route path="/youth/session-docs" element={<R roles={HEAT_ROLES}><SessionDocumentationPage program="youth" /></R>} />

      {/* Client + Staff pages (includes housing residents, not agency) */}
      <Route path="/checkin" element={<R roles={CLIENT_AND_STAFF}><CheckInPage /></R>} />
      <Route path="/check-in" element={<R roles={CLIENT_AND_STAFF}><CheckInPage /></R>} />
      <Route path="/checkins" element={<R roles={STAFF}><CheckinsPage /></R>} />
      <Route path="/goals" element={<R roles={CLIENT_AND_STAFF}><GoalsPage /></R>} />
      <Route path="/appointments" element={<R roles={CLIENT_AND_STAFF}><AppointmentsPage /></R>} />
      <Route path="/documents" element={<R roles={CLIENT_AND_STAFF}><DocumentsPage /></R>} />
      <Route path="/bio" element={<R roles={CLIENT_AND_STAFF}><BioPage /></R>} />
      <Route path="/roadmap" element={<R roles={CLIENT_AND_STAFF}><RoadmapPage /></R>} />
      <Route path="/employment" element={<R roles={CLIENT_AND_STAFF}><EmploymentHubPage /></R>} />
      <Route path="/achievements" element={<R roles={[...CLIENT, ...RESIDENT, ...STAFF]}><AchievementsPage /></R>} />
      <Route path="/wallet" element={<R roles={[...CLIENT, ...RESIDENT]}><ResourceWalletPage /></R>} />
      <Route path="/alumni" element={<R roles={[...CLIENT, ...RESIDENT, ...STAFF]}><AlumniNetworkPage /></R>} />
      <Route path="/mentorship" element={<R roles={[...CLIENT, ...RESIDENT, ...STAFF]}><AlumniNetworkPage /></R>} />
      <Route path="/journey" element={<R roles={CLIENT_AND_STAFF}><JourneyPage /></R>} />
      <Route path="/journey-report" element={<R roles={CLIENT_AND_STAFF}><JourneyReportPage /></R>} />
      <Route path="/courses" element={<R roles={CLIENT_AND_STAFF}><CoursesPage /></R>} />
      <Route path="/opportunities" element={<R roles={CLIENT_AND_STAFF}><OpportunitiesPage /></R>} />
      <Route path="/my-opportunities" element={<R roles={CLIENT_AND_STAFF}><MyOpportunitiesPage /></R>} />
      <Route path="/geofencing" element={<R roles={CLIENT_AND_STAFF}><GeofencingPage /></R>} />

      {/* Staff-only pages (not clients, not residents, not agency) */}
      <Route path="/clients" element={<R roles={[...STAFF, ...AGENCY]}><ClientsPage /></R>} />
      <Route path="/specialists" element={<R roles={ADMIN}><ClientsPage /></R>} />
      <Route path="/session-notes" element={<R roles={STAFF}><SessionNotesPage /></R>} />
      <Route path="/peer-docs" element={<R roles={STAFF}><PeerDocsPage /></R>} />
      <Route path="/group-notes" element={<R roles={STAFF}><GroupNotesPage /></R>} />
      <Route path="/flags" element={<R roles={STAFF}><FlagsPage /></R>} />
      <Route path="/group-sessions" element={<R roles={[...STAFF, ...AGENCY]}><GroupSessionsPage /></R>} />
      <Route path="/calendar" element={<R roles={STAFF}><CalendarPage /></R>} />
      <Route path="/referrals" element={<R roles={STAFF}><ReferralsPage /></R>} />
      <Route path="/insights" element={<R roles={STAFF}><InsightsPage /></R>} />
      <Route path="/digest" element={<R roles={[...STAFF, ...AGENCY]}><DigestPage /></R>} />

      {/* Admin/Coordinator only */}
      <Route path="/approval-queue" element={<R roles={ADMIN}><ApprovalQueuePage /></R>} />
      <Route path="/magic-links" element={<R roles={ADMIN}><MagicLinksPage /></R>} />
      <Route path="/analytics" element={<R roles={[...ADMIN, ...AGENCY]}><AnalyticsPage /></R>} />
      <Route path="/compliance" element={<R roles={[...ADMIN, ...AGENCY]}><CompliancePage /></R>} />
      <Route path="/users" element={<R roles={ADMIN}><UsersPage /></R>} />
      <Route path="/programs" element={<R roles={[...ADMIN, ...AGENCY]}><ProgramsPage /></R>} />
      <Route path="/referral-management" element={<R roles={ADMIN}><ReferralManagementPage /></R>} />
      <Route path="/organization-profile" element={<R roles={[...ADMIN, ...PARTNER]}><OrganizationProfilePage /></R>} />
      <Route path="/post-opportunity" element={<R roles={[...ADMIN, ...PARTNER]}><PostOpportunityPage /></R>} />
      <Route path="/service-ledger" element={<R roles={[...STAFF]}><ServiceLedgerPage /></R>} />
      <Route path="/impact" element={<R roles={ADMIN}><ImpactDashboardPage /></R>} />
      <Route path="/security" element={<R roles={ADMIN}><AdminSecurityDashboard /></R>} />
      <Route path="/connections" element={<R roles={[...STAFF]}><ConnectionsPage /></R>} />

      {/* Reports & Funder Tools */}
      <Route path="/reports/roi" element={<R roles={[...ADMIN, ...AGENCY]}><ROICalculatorPage /></R>} />
      <Route path="/reports/recidivism" element={<R roles={[...ADMIN]}><RecidivismTrackingPage /></R>} />
      <Route path="/reports/impact" element={<R roles={[...ADMIN]}><ImpactReportPage /></R>} />
      <Route path="/reports/compliance" element={<R roles={[...STAFF, ...AGENCY]}><ComplianceReportPage /></R>} />

      {/* Phase 9C: Court System & Risk Assessment */}
      <Route path="/court" element={<R roles={[...STAFF, ...AGENCY]}><CourtCasesPage /></R>} />
      <Route path="/risk" element={<R roles={[...STAFF, ...AGENCY]}><RiskDashboardPage /></R>} />
      <Route path="/notifications-scheduler" element={<R roles={ADMIN}><NotificationSchedulerPage /></R>} />

      {/* CORE-8 Profile Assessment & Risk Engine */}
      <Route path="/core8" element={<R roles={[...CLIENT_AND_STAFF]}><Core8AssessmentPage /></R>} />
      <Route path="/risk-engine" element={<R roles={[...STAFF, ...AGENCY]}><RiskEnginePage /></R>} />
      <Route path="/risk-engine/:participantId" element={<R roles={[...STAFF, ...AGENCY]}><RiskEnginePage /></R>} />
      <Route path="/my-support" element={<R roles={[...CLIENT, ...RESIDENT]}><MySupportStatusPage /></R>} />

      {/* Incident & Compliance + Regions */}
      <Route path="/incidents" element={<R roles={[...STAFF]}><IncidentCompliancePage /></R>} />
      <Route path="/regions" element={<R roles={ADMIN}><RegionsPage /></R>} />

      {/* Community Partner routes */}
      <Route path="/partner-portal" element={<R roles={[...PARTNER, ...ADMIN]}><CommunityPartnerPortal /></R>} />

      {/* Participant needs/skills */}
      <Route path="/my-needs" element={<R roles={[...CLIENT, ...RESIDENT]}><MyNeedsPage /></R>} />

      {/* Housing management */}
      <Route path="/housing" element={<R roles={[...STAFF, ...HOUSING]}><HousingPage /></R>} />

      {/* Agency / Referral Source view */}
      <Route path="/agency-view" element={<R roles={[...AGENCY, ...ADMIN]}><AgencyViewPage /></R>} />

      {/* Scoreboard — staff see full leaderboard, residents see own score */}
      <Route path="/scoreboard" element={<R roles={[...ALL_STAFF, ...CLIENT, ...RESIDENT]}><ScoreboardPage /></R>} />

      {/* Our Square Housing Staff Routes */}
      <Route path="/our-square" element={<R roles={HOUSING}><OurSquarePage subpage="dashboard" /></R>} />
      <Route path="/our-square/properties" element={<R roles={HOUSING}><OurSquarePage subpage="properties" /></R>} />
      <Route path="/our-square/residents" element={<R roles={HOUSING}><OurSquarePage subpage="residents" /></R>} />
      <Route path="/our-square/meetings" element={<R roles={HOUSING}><OurSquarePage subpage="meetings" /></R>} />
      <Route path="/our-square/incidents" element={<R roles={HOUSING}><OurSquarePage subpage="incidents" /></R>} />
      <Route path="/our-square/waitlist" element={<R roles={HOUSING}><OurSquarePage subpage="waitlist" /></R>} />
      <Route path="/our-square/rent" element={<R roles={HOUSING}><OurSquarePage subpage="rent" /></R>} />
      <Route path="/our-square/reports" element={<R roles={HOUSING}><OurSquarePage subpage="reports" /></R>} />
      <Route path="/our-square/referrals" element={<R roles={HOUSING}><OurSquarePage subpage="referrals" /></R>} />
      <Route path="/our-square/curriculum" element={<R roles={HOUSING}><StaffCurriculumDashboard /></R>} />
      <Route path="/our-square/intake" element={<R roles={HOUSING}><IntakeApplicationsPage /></R>} />
      <Route path="/our-square/milestones" element={<R roles={HOUSING}><MilestonesPage /></R>} />
      <Route path="/our-square/referral-sources" element={<R roles={HOUSING}><ReferralSourcesPage /></R>} />
      <Route path="/our-square/documents" element={<R roles={HOUSING}><HousingDocumentsPage /></R>} />
      <Route path="/our-square/staff-dashboard" element={<R roles={HOUSING}><StaffDashboardPage /></R>} />
      <Route path="/our-square/risk-scoring" element={<R roles={HOUSING}><RiskScoringPage /></R>} />
      <Route path="/our-square/compliance-reports" element={<R roles={HOUSING}><ComplianceReportsPage /></R>} />
      <Route path="/our-square/compliance-dashboard" element={<R roles={HOUSING}><ComplianceDashboardPage /></R>} />
      <Route path="/our-square/onboarding" element={<R roles={[...HOUSING, ...ADMIN]}><OnboardingPage /></R>} />
      <Route path="/curriculum" element={<R roles={HOUSING}><StaffCurriculumDashboard /></R>} />

      {/* Housing Resident Portal */}
      <Route path="/my-progress" element={<R roles={[...RESIDENT, ...HOUSING]}><ResidentPortal /></R>} />
      <Route path="/my-milestones" element={<R roles={[...RESIDENT, ...HOUSING]}><ResidentMilestonesPage /></R>} />
      <Route path="/my-documents" element={<R roles={[...RESIDENT, ...HOUSING]}><ResidentDocumentsPage /></R>} />

      <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
